@if ((isEditAvailable$ | async)) {
  @for (editMode of (editModes$ | async); track editMode) {
    <button ngbDropdownItem
      [routerLink]="[getEditItemRoute(), contextMenuObject.id + ':' + editMode.name]"
      [innerHTML]="editMode.label ? (editMode.label | translate) : ('context-menu.actions.edit-item.btn.' + editMode.name | translate)">
    </button>
  }
}
